module.exports = __webpack_public_path__ + "static/media/deadline.5dcfa019.svg";